import { apiClient } from '../config/api';

export class RepasseService {
  static async list(params?: any) {
    // Adiciona include para trazer dados relacionados
    const enrichedParams = {
      ...params,
      include: 'clienteData,documento'
    };
    const qs = new URLSearchParams(enrichedParams).toString();
    return apiClient.request<any>(`/repasses?${qs}`);
  }

  static async get(id: string) {
    return apiClient.request<any>(`/repasses/${id}`);
  }

  static async create(payload: any) {
    return apiClient.request<any>(`/repasses`, { method: 'POST', body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json' } });
  }

  static async update(id: string, payload: any) {
    return apiClient.request<any>(`/repasses/${id}`, { method: 'PUT', body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json' } });
  }

  static async remove(id: string) {
    return apiClient.request<any>(`/repasses/${id}`, { method: 'DELETE' });
  }
}

export const repasseService = RepasseService;
